(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const toast = $('[data-toast]');
  let toastTimer;

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  const menuButton = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    mobileMenu.hidden = !open;
    document.body.classList.toggle('menu-open', open);
  });

  const searchButton = $('[data-search-toggle]');
  const searchPanel = $('[data-search-panel]');
  searchButton?.addEventListener('click', () => {
    searchPanel.hidden = !searchPanel.hidden;
    if (!searchPanel.hidden) $('input', searchPanel)?.focus();
  });

  $$('details.nav-dropdown').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      $$('details.nav-dropdown').forEach((other) => {
        if (other !== details) other.open = false;
      });
    });
  });

  $$('[data-qty-minus], [data-qty-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const picker = button.closest('.quantity-picker');
      const input = $('input[type="number"]', picker);
      if (!input) return;
      const value = Number(input.value || 1);
      input.value = button.hasAttribute('data-qty-plus') ? value + 1 : Math.max(1, value - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  $$('.product-form input[type="radio"][name="id"]').forEach((input) => {
    input.addEventListener('change', () => {
      const productInfo = input.closest('.product-info');
      if (!productInfo) return;
      const price = $('[data-product-price]', productInfo);
      const comparePrice = $('[data-product-compare-price]', productInfo);
      const saving = $('[data-product-saving]', productInfo);
      const addButton = $('[data-product-add]', productInfo);
      const hasSaving = Boolean(input.dataset.variantComparePrice);
      const available = input.dataset.variantAvailable === 'true';

      if (price) price.textContent = input.dataset.variantPrice || '';
      if (comparePrice) {
        comparePrice.textContent = input.dataset.variantComparePrice || '';
        comparePrice.hidden = !hasSaving;
      }
      if (saving) {
        saving.textContent = hasSaving ? `${input.dataset.variantSaving}% OFF` : '';
        saving.hidden = !hasSaving;
      }
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to cart' : 'Sold out';
      }
    });
  });

  $$('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-gallery]');
      $$('[data-gallery-thumb]', gallery).forEach((item) => item.classList.remove('is-active'));
      $$('.gallery-media', gallery).forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
      $(`[data-gallery-media="${button.dataset.galleryThumb}"]`, gallery)?.classList.add('is-active');
    });
  });

  $$('[data-tab]').forEach((button) => {
    button.addEventListener('click', () => {
      const tabList = button.closest('.tab-list');
      $$('[data-tab]', tabList).forEach((tab) => tab.setAttribute('aria-selected', String(tab === button)));
      const panel = tabList.nextElementSibling;
      if (!panel) return;
      if (button.dataset.tab !== 'description') {
        showToast(`${button.textContent.trim()} content can be managed from the product description and metafields.`);
      }
    });
  });

  const filterPanel = $('[data-filter-panel]');
  $('[data-filter-toggle]')?.addEventListener('click', () => filterPanel?.classList.toggle('is-open'));

  $('[data-sort-by]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    if (event.target.value.includes('_') || event.target.value === 'best-selling' || event.target.value === 'manual') {
      window.location.assign(url.toString());
    }
  });

  $$('[data-play-video]').forEach((button) => button.addEventListener('click', () => showToast('Add a YouTube or Shopify-hosted video URL in this section to play the full guide.')));

  $('[data-copy-link]')?.addEventListener('click', async () => {
    const input = $('[data-referral-link]');
    if (!input) return;
    try {
      await navigator.clipboard.writeText(input.value);
      showToast('Referral link copied.');
    } catch {
      input.select();
      document.execCommand('copy');
      showToast('Referral link copied.');
    }
  });

  $$('form.card-product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch) return;
      event.preventDefault();
      const button = $('button[type="submit"]', form);
      button?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add item');
        showToast('Added to your cart.');
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        $$('.cart-link > span').forEach((count) => { count.textContent = cart.item_count; });
      } catch (error) {
        showToast(error.message || 'Please try again.');
      } finally {
        button?.removeAttribute('aria-busy');
      }
    });
  });
})();
